/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const BloqueDTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueDCollapsed,
  setBloqueDCollapsed,
  btlMensualesCombinados,
  ingresosBTLMensual,
  monthsToShow,
  openBTLModal,
  formatCurrency,
  formatPercentage,
  ytdIngresosBTL,
  comisionEdificiosBTLMensual,
  ytdComisionEdificiosBTL,
  otrosCostosBTLMensual,
  ytdOtrosCostosBTL,
  margenBTLMensual,
  ytdMargenBTL,
  porcentajeSobreFacturacion,
  margenPorcentaje,
}) => (
  <>
    {/* === BLOQUE D - BTL & otros === */}
    <tr
      className={styles.sectionHeader}
      onClick={() => !modoCombinado && setBloqueDCollapsed(!bloqueDCollapsed)}
      style={{ cursor: modoCombinado ? "default" : "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCell}>
        D - BTL & otros {!modoCombinado && !verUltimos12Meses && bloqueDCollapsed ? ">" : ""}
      </td>
      {(modoCombinado ? btlMensualesCombinados : ingresosBTLMensual).map((val, i) => (
        <td
          key={i}
          className="text-end"
          onClick={(e) => {
            e.stopPropagation();
            if (!modoCombinado && i < monthsToShow && val > 0) openBTLModal(i);
          }}
          style={{ cursor: !modoCombinado && i < monthsToShow && val > 0 ? "pointer" : "default" }}
        >
          {i < monthsToShow ? formatCurrency(val, i, null, modoCombinado) : "-"}
        </td>
      ))}
      <td className={styles.totalCell}>
        {modoCombinado
          ? formatCurrency(
              btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )
          : formatCurrency(ytdIngresosBTL, null, ingresosBTLMensual)}{" "}
        |{" "}
        {porcentajeSobreFacturacion(
          modoCombinado ? btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) : ytdIngresosBTL
        )}
      </td>
    </tr>

    {!modoCombinado && !bloqueDCollapsed && (
      <>
        {/* Comisión edificios */}
        <tr>
          <td className={styles.conceptCell}>Comisión edificios</td>
          {comisionEdificiosBTLMensual.map((val, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdComisionEdificiosBTL, null, comisionEdificiosBTLMensual)} |{" "}
            {ytdIngresosBTL > 0 ? formatPercentage((ytdComisionEdificiosBTL / ytdIngresosBTL) * 100) : "0%"}
          </td>
        </tr>

        {/* Otros costos */}
        <tr>
          <td className={styles.conceptCell}>Otros costos</td>
          {otrosCostosBTLMensual.map((val, i) => (
            <td
              key={i}
              className="text-end"
              onClick={(e) => {
                e.stopPropagation();
                if (i < monthsToShow && ingresosBTLMensual[i] > 0) openBTLModal(i);
              }}
              style={{ cursor: i < monthsToShow && ingresosBTLMensual[i] > 0 ? "pointer" : "default" }}
            >
              {i < monthsToShow ? formatCurrency(val, i) : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {formatCurrency(ytdOtrosCostosBTL, null, otrosCostosBTLMensual)} |{" "}
            {ytdIngresosBTL > 0 ? formatPercentage((ytdOtrosCostosBTL / ytdIngresosBTL) * 100) : "0%"}
          </td>
        </tr>

        {/* Contribución D */}
        <tr className={styles.marginRow}>
          <td className={styles.conceptCellMargen}>Contribución</td>
          {margenBTLMensual.map((val, i) => (
            <td key={i} className="text-end">
              <div className={val < 0 ? styles.marginNegative : ""}>
                {i < monthsToShow ? formatCurrency(val, i) : "-"}
              </div>
            </td>
          ))}
          <td className={styles.totalCell}>
            <div className={ytdMargenBTL < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ytdMargenBTL, null, margenBTLMensual)} | {margenPorcentaje(ytdMargenBTL, ytdIngresosBTL)}
            </div>
          </td>
        </tr>
      </>
    )}
  </>
);
